import { decode } from 'js-base64'
import Cookies from 'js-cookie'

const readJwtPayload = () => {
  const jwt = Cookies.get('jwt')
  if (!jwt) return null
  const payload = jwt.split('.')[1]
  if (!payload) return null
  try {
    return JSON.parse(decode(payload))
  } catch {
    return null
  }
}

/**
 * Whether a staff user is impersonating a customer via "Login as user".
 * Detected by the presence of an `employee_id` claim in the JWT (BE-2771).
 *
 * Used to suppress customer identification (Sentry, Intercom) in a staff
 * browser so impersonation sessions are not attributed to the customer.
 *
 * Returns false on any decode failure, so identification still happens for
 * legitimate users with malformed/legacy tokens.
 */
export const isStaffImpersonating = () => {
  const payload = readJwtPayload()
  return typeof payload?.employee_id === 'number'
}
